import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/spinner.svg';
import { Icon } from '../Icon/Icon';
export const SpinnerIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
